<template>
  <div class="md:p-24 p-6 bg-gray-100 max-w-5xl rounded-xl m-auto">
    <div v-if="started === false">
      <h2 class="text-3xl text-center">Łączenie w pary</h2>
      <p class="text-lg text-center mt-2 text-gray-500">Połącz wybrane obrazy w pary aby do siebie pasowały</p>
      <button class="quiz-button text-white hover:text-white bg-ekopleszew-primary hover:bg-ekopleszew-light mt-4 mx-auto" @click="runGame()">Rozpocznij grę</button>
    </div>
    <div v-else-if="started === true && items.length > correct.length">
      <span class="text-3xl text-center block">Łączenie w pary</span>
      <p class="text-lg text-center mt-2 text-gray-500">Połącz wybrane obrazy w pary aby do siebie pasowały</p>
      <div class="mt-4">
        <div class="grid grid-cols-5 gap-2 content-end">
          <div class="rounded-xl text-center" v-for="(item, index) in items.filter((itm) => itm.items.length < 2 && itm.items.length > 0)" :key="index">
            <draggable v-model="item.items" :group="{ name: `item-${item.id}`, revertClone: false }" item-key="id" @change="onChange" @end="onEnd">
              <template #item="{element}">
                <img :src="`${baseUrl}images/pairing/laczeniewpary_0${element.id}-l.png`" class="inline-block"/>
              </template>
            </draggable>
          </div>
          <div class="py-12 col-span-5 w-full">
            <div class="w-full border-t-2 border-gray-300"></div>
          </div>
            <div class="rounded-xl text-center" v-for="(item, index) in itemsShuffled.filter((itm) => itm.items.length < 2 && itm.items.length > 0)" :key="index">
              <draggable v-model="item.items" :group="{ name: `item-${item.id}`, revertClone: false }" item-key="id" @change="onChange" @end="onEnd">
                <template #item="{element}">
                  <img :src="`${baseUrl}images/pairing/laczeniewpary_0${element.id}-p.png`" class="inline-block"/>
                </template>
              </draggable>
            </div>
        </div>
      </div>
      <div class="my-5" v-if="correct.length > 0">
        <span class="text-lg text-center block my-5">Dopasowane obrazki:</span>
        <div class="grid grid-cols-5 gap-2 content-center">
          <div v-for="(item, index) in correct" :key="index">
            <img :src="`${baseUrl}images/pairing/laczeniewpary_0${item.id}.png`" class="rounded-lg"/>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <span class="text-3xl text-center block mb-6">Brawo, połączyłeś wszystkie obrazki prawidłowo!</span>
      <div class="grid grid-cols-5 gap-2 content-center">
        <div v-for="(item, index) in correct" :key="index">
          <img :src="`${baseUrl}images/pairing/laczeniewpary_0${item.id}.png`" class="rounded-lg"/>
        </div>
      </div>
      <button class="quiz-button text-white hover:text-white bg-ekopleszew-primary hover:bg-ekopleszew-light mt-8 mx-auto" @click="runGame()">Zagraj ponownie</button>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      started: false,
      items: [],
      itemsShuffled: []
    }
  },
  computed: {
    correct() {
      return [...this.itemsShuffled.filter((itm) => itm.items.length === 2), ...this.items.filter((itm) => itm.items.length === 2)]
    }
  },
  methods: {
    runGame() {
      this.started = true
      this.items = [
        { id: 1, items: [{id: 1}] },
        { id: 2, items: [{id: 2}] },
        { id: 3, items: [{id: 3}] },
        { id: 4, items: [{id: 4}] },
        { id: 5, items: [{id: 5}] },
        { id: 6, items: [{id: 6}] },
        { id: 7, items: [{id: 7}] },
        { id: 8, items: [{id: 8}] },
        { id: 9, items: [{id: 9}] },
        { id: 10, items: [{id: 10}] },
      ]
      this.items.sort( () => Math.random() - 0.5)
      this.itemsShuffled = JSON.parse(JSON.stringify(this.items))
      this.itemsShuffled.sort( () => Math.random() - 0.5)
      this.correct = []
    },
    onChange(item) {
      if (item.added === undefined) {
        return
      }
      this.correct.push(item.added.element)
    },
    onEnd() {
      return false
      // return (evt.draggedContext.element.name!=='apple');
    },
    shuffle(a) {

      return a;
    }
  }
}
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>